import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'
import inventoryPrivilegeFormModel from '@/models/inventory/inventory-privilege-form'
import router from '@/router'
import store from '@/store'
import useFilterHeaderTable from '@/views/components/filter-header-table/useFilterHeaderTable'
import usePagination from '@/views/components/pagination/usePagination'
import {
  getCurrentInstance,
  onBeforeMount,
  reactive,
  watch,
} from '@vue/composition-api'
import useInventoryManageCustom from './useInventoryManageCustom'

export default function useTransferStock(props) {
  const vm = getCurrentInstance().proxy
  const {
    resolveStatusClass,
    resolveStatusLabel,
  } = useInventoryManageCustom()
  const { fetchTransferInventoryList } = inventoryPrivilegeFormModel()
  const { pagination, onPageChange } = usePagination()
  const { filters, ordering, onSetValueSearch } = useFilterHeaderTable()
  const { openDefaultErrorModal, openErrorModal } = useValidationModal()

  const loading = reactive({
    tableData: false,
    tableOverlay: false,
  })

  const inventoryList = reactive({
    payload: [],
  })

  const fields = [
    { key: 'no', label: 'No.' },
    { key: 'name', label: 'Inventory Name' },
    { key: 'alt_reference', label: 'Reference' },
    { key: 'actions', label: '' },
  ]

  const fetchInventoryList = (showLoading = true) => {
    if (showLoading) {
      loading.tableData = true
    }
    fetchTransferInventoryList.payload.Inventory_Id = router.currentRoute.params.ref
    fetchTransferInventoryList.payload.Privilege_Id = props.rewardDetail.privilege_id
    fetchTransferInventoryList.payload.Page = pagination.currentPage
    fetchTransferInventoryList.payload.Limit = pagination.perPage
    fetchTransferInventoryList.payload.Filters = filters
    fetchTransferInventoryList.payload.Ordering = ordering.value
    store
      .dispatch('api/apiRequest', fetchTransferInventoryList)
      .then(response => {
        inventoryList.payload = response.data.payload
        pagination.rows = response.data.payload.length
        pagination.totalRows = response.data.filtered_record
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        loading.tableData = false
        loading.tableOverlay = false
      })
  }

  const selectInventory = inventory => {
    vm.$emit('onSelectInventory', inventory)
  }

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchInventoryList()
      }
    },
    { deep: true },
  )

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1

      fetchInventoryList()
    },
    { deep: true },
  )

  const onModalOpen = () => {
    // ToDo
  }

  onBeforeMount(() => {
    fetchInventoryList()
  })

  return {
    pagination,
    fields,
    loading,
    inventoryList,
    onModalOpen,
    resolveStatusClass,
    resolveStatusLabel,
    onPageChange,
    onSetValueSearch,
    selectInventory,
  }
}
